<template>
  <div class="file-upload-single-item">
    <div class="file-upload-single-item-name">
      {{ file.name }}
    </div>
    <button
      type="button"
      class="btn-text btn-text--primary"
      @click="$emit('remove')"
    >
      {{ "Kompletiraj" }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'vuestic-file-upload-single-item',
  props: {
    file: {
      type: Object,
    },
  },
}
</script>

<style lang='scss'>
@import "../../../../sass/_variables.scss";

.file-upload-single-item {
  display: flex;

  &-name {
    margin-right: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/anaassays/vuestic-datatable/upload/AssayFileUploadSingleItem.vue